import {
   rand,
   randWord,
   randNumber,
   randSequence,
   randBoolean,
   randRecentDate,
   randFutureDate,
   randProductName,
   randFullName,
   randAirportCode,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';
import { dateTimeFormat } from '@library/common/models';

import moment from 'moment';

import { MockBillingParty } from '@library/common/models/mock';

import { MockLeg } from './cartage-leg.mock';

import { CartageItemTypes } from '../cartage-item-types';
import { CartageBase, CartageBlockedActionTypes } from '../cartage-base';

export class MockCartageBase extends CartageBase {
   constructor( type?: CartageItemTypes ) {
      super();

      this.type = type || rand([ ...CartageItemTypes ]);
      this.job = randNumber({ max: 9999999999 });

      if ( optional() ) { this.proNumber = randSequence({ size: 12 }); }

      if ( this.type === 'pickup' ) {
         this.successorLeg = new MockLeg();
      } else if ( this.type === 'delivery' ) {
         this.predecessorLeg = new MockLeg();
      }

      this.pickupLocation = new MockBillingParty();
      this.pickupDate = randRecentDate({ days: 10 }).toString();
      this.pickupTime = moment( randRecentDate({ days: 10 }) ).format( 'HH:mm:ss' );

      this.deliveryLocation = new MockBillingParty();
      this.deliveryDate = randFutureDate().toString();
      this.deliveryTime = moment( randFutureDate() ).format( 'HH:mm:ss' );

      if ( optional() ) { this.serviceLevel = randProductName(); }

      if ( optional( 40 ) ) { this.driver = randFullName(); }

      if ( optional() ) { this.dangerousGoods = randBoolean(); }

      if ( optional()) { this.origin = randAirportCode(); }
      if ( optional()) { this.destination = randAirportCode(); }

      this.blockedActions = [ ...new Set(
         Array.from({
            length: randNumber( { min: 1, max: CartageBlockedActionTypes.length } )
         }, _ => rand( Array.from( CartageBlockedActionTypes ) ))
      )];

      this.statuses = Array.from({ length: randNumber({ min: 1, max: 10 })}, _ => ({
         code: randWord(),
         status: randProductName(),
         dateTime: optional() ? undefined : moment(randRecentDate({ days: 10 })).format( dateTimeFormat )
      }));
   }
}
